var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.72 35.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n        opacity: .3;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #8c9091;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.01,5.09c-6.29-.61-11.54,4.58-11.03,10.85,0,.17.03.34.06.51.94.21,1.91.32,2.91.32.3,0,.6-.01.9-.03-.05-.19-.09-.38-.12-.58-.72-4.35,3.01-8.08,7.36-7.36,1.19.2,2.27.73,3.14,1.51.64-1.09,1.13-2.28,1.43-3.54-1.35-.93-2.94-1.54-4.65-1.7v.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.22,27.18l-6.13-6.13c1.38-1.87,2.14-4.22,1.94-6.76-.37-4.81-4.22-8.75-9.02-9.21-6.29-.6-11.54,4.59-11.03,10.86.39,4.73,4.08,8.57,8.79,9.13,2.45.29,4.74-.31,6.61-1.5l6.24,6.24c1.79,1.68,4.27-.86,2.58-2.63h.02ZM6.73,16.18c-.72-4.35,3.01-8.08,7.36-7.36,2.64.44,4.76,2.56,5.2,5.2.72,4.35-3.01,8.08-7.36,7.36-2.64-.44-4.76-2.56-5.2-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.66,6.79c-.3,1.26-.79,2.45-1.43,3.54-.87-.77-1.95-1.31-3.14-1.51-4.35-.72-8.08,3.01-7.36,7.36.03.19.07.39.12.58-.3.02-.6.03-.9.03-1,0-1.97-.11-2.91-.32l-.06-.51c-.51-6.29,4.74-11.48,11.03-10.87,1.71.17,3.3.77,4.65,1.7Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.6d579469ab057545db437012c1cc38b5.svg";
export { ForwardRef as ReactComponent };